import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

interface Props {
  badgeStyle?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
  testID?: string;
}

export const BadgeAbsolute: React.FC<Props> = ({
  badgeStyle,
  children,
  testID,
}) => {
  const [styles] = useStyles();
  return children ? (
    <View
      accessibilityLabel="badge-absolute"
      style={[styles.badge, badgeStyle]}
      testID={testID}
    >
      {children}
    </View>
  ) : (
    <View
      accessibilityLabel="badge-absolute"
      style={[styles.badge, badgeStyle]}
      testID={testID}
    />
  );
};

const BADGE_SIZE = 10;

const useStyles = createStyles((theme) => ({
  badge: {
    backgroundColor: theme.sk.color.bg.system.badge,
    borderRadius: BADGE_SIZE / 2,
    height: BADGE_SIZE,
    position: 'absolute',
    right: -2,
    top: -1,
    width: BADGE_SIZE,
    zIndex: 1,
  },
}));
